import { buildService } from './service';
import serviceMethods from './service_methods';
import { useCallback, useMemo, useRef, useState } from 'react';
const api = buildService('/user_table_setups', {
  only: ['get', 'create', 'update']
});
const useFetchTableSetup = _ref => {
  let {
    tableName,
    defaultTableSetup,
    setLoading,
    fetchImmediately = true
  } = _ref;
  const [tableSetupExists, setTableSetupExists] = useState(false);
  const setTableSetupRef = useRef(null);
  const overrideHttpStatusErrorHandlers = useMemo(() => ({
    404: () => {
      setTableSetupExists(false);
      setTableSetupRef.current(defaultTableSetup);
    }
  }), [defaultTableSetup]);
  const [tableSetup, setTableSetup, fetchTableSetup] = serviceMethods.useFetch({
    callback: useCallback(async () => {
      if (!tableName) return defaultTableSetup;
      const userTableSetup = await api.get(tableName);
      setTableSetupExists(true);
      return userTableSetup.config;
    }, [defaultTableSetup, tableName]),
    setLoading,
    initialStateValue: null,
    fetchImmediately,
    overrideHttpStatusErrorHandlers
  });
  setTableSetupRef.current = setTableSetup;
  return {
    tableSetup,
    setTableSetup,
    fetchTableSetup,
    tableSetupExists,
    setTableSetupExists
  };
};
const useCreateTableSetup = _ref2 => {
  let {
    tableName,
    setTableSetup,
    setTableSetupExists,
    setLoading
  } = _ref2;
  const createTableSetup = serviceMethods.useCreate({
    callback: useCallback(async tableSetup => {
      const userTableSetup = await api.create({
        user_table_setup: {
          table_name: tableName,
          config: tableSetup
        }
      });
      setTableSetup(userTableSetup.config);
      setTableSetupExists(true);
      return userTableSetup;
    }, [setTableSetup, setTableSetupExists, tableName]),
    setLoading
  });
  return createTableSetup;
};
const useUpdateTableSetup = _ref3 => {
  let {
    tableName,
    setTableSetup,
    setLoading
  } = _ref3;
  const updateTableSetup = serviceMethods.useUpdate({
    callback: useCallback(async tableSetup => {
      const userTableSetup = await api.update(tableName, {
        user_table_setup: {
          table_name: tableName,
          config: tableSetup
        }
      });
      setTableSetup(userTableSetup.config);
      return userTableSetup;
    }, [setTableSetup, tableName]),
    setLoading
  });
  return updateTableSetup;
};
const useSaveTableSetup = _ref4 => {
  let {
    tableName,
    tableSetupExists,
    setTableSetup,
    setTableSetupExists,
    setLoading
  } = _ref4;
  const createTableSetup = useCreateTableSetup({
    tableName,
    setTableSetup,
    setTableSetupExists,
    setLoading
  });
  const updateTableSetup = useUpdateTableSetup({
    tableName,
    setTableSetup,
    setLoading
  });
  const saveTableSetup = useCallback(tableSetup => {
    return tableSetupExists ? updateTableSetup(tableSetup) : createTableSetup(tableSetup);
  }, [createTableSetup, tableSetupExists, updateTableSetup]);
  return saveTableSetup;
};
const userTableSetupService = {
  useFetchTableSetup,
  useSaveTableSetup
};
export default userTableSetupService;